<script lang="ts">
  import { browser } from "$app/environment";
  import { page } from "$app/stores";
  import {
    headerMax,
    activeSection,
    archiveBar,
    mobileView,
    activeColor,
    schedule_height,
    background_bar_height,
  } from "$lib/data";

  let selected = 0;

  const backgrounds = [
    {
      section: "show",
      color: "#fe5f75",
      gradient:
        "linear-gradient(-90deg, rgba(246,227,128,1) 0%, rgba(255,113,113,1) 100%)",
    },
    {
      section: "episodes",
      color: "#58427c",
      gradient:
        "linear-gradient(90deg, rgba(74,95,120,1) 0%, rgba(102,154,177,1) 100%)",
    },
    {
      section: "guests",
      color: "#f9c5d1",
      gradient: "linear-gradient(315deg, #f9c5d1 0%, #9795ef 74%)",
    },
    {
      section: "extras",
      color: "#738bdc",
      gradient:
        "linear-gradient(-90deg, rgba(57,34,89,1) 0%, rgba(47,52,88,1) 100%)",
    },

    {
      section: "home",
      color: "#fff",
      gradient: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23dde5f1' fill-opacity='0.34' fill-rule='evenodd'/%3E%3C/svg%3E")`,
    },
    {
      section: "community",
      color: "#4b7cc8",
      gradient:
        "linear-gradient(0deg, rgba(46,80,133,1) 0%, rgba(75,124,200,1) 100%)",
    },
  ];
  $: episode_selected =
    $page.url.pathname === "/episodes" ||
    $page.url.pathname === "/episodes/schedule" ||
    $page.url.pathname === "/events" ||
    $page.url.pathname === "/episodes/upcoming"
      ? 4
      : 1;

  // background funtion to parse the change in section and apply the correct background
  const switcher = (section: string) => {
    if (!browser) return;
    let lastSection: string | undefined;
    // escape early if the section is already correct
    if ((lastSection && lastSection === section) || !browser) return;

    switch (section) {
      case "show":
        selected = 0;
        $activeColor = 1;
        break;
      case "episodes":
        selected = episode_selected;
        $activeColor = 0;
        break;
      case "guests":
        selected = 2;
        $activeColor = 2;
        break;
      case "extras":
        selected = 3;
        $activeColor = 3;
        break;
      case "community":
        selected = 5;
        $activeColor = 5;
        break;
      default:
        selected = 4;
        $activeColor = 4;
        break;
    }
    lastSection = section;
  };

  // set the background color based on the activeSection
  $: $page.url, switcher($activeSection);

  $: if (
    ($page.url.pathname == "/episodes" && browser) ||
    ($page.url.pathname == "/events" && browser) ||
    ($page.url.pathname == "/episodes/upcoming" && browser)
  ) {
    $background_bar_height = $archiveBar;
  } else if ($page.url.pathname == "/" && browser) {
    $background_bar_height = 530;
  } else if ($page.url.pathname == "/episodes/schedule" && browser) {
    $background_bar_height = $schedule_height;
  } else {
    if (browser) $background_bar_height = 500;
  }

  let margin: number = 60;
  $: if (browser) {
    margin = $mobileView ? 60 : $headerMax;
  }
</script>

{#each backgrounds as bar, index}
  <div
    class="backgroundBar {bar.section}"
    style="
            top: {margin}px;
            background-color: {backgrounds[index].color};
            background-image: {backgrounds[index].gradient};
            height: {$background_bar_height}px;
        "
    class:active={selected === index}
  >
    {#if bar.section !== "home"}
      <svg
        viewBox="0 0 1500 100"
        version="1.1"
        class="wave"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:svg="http://www.w3.org/2000/svg"
      >
        <path
          d="m 0,57.150185 c 0,0 285.23944,-30 750,-30 464.7606,0 750,30 750,30 V 100 H 0 Z"
        />
      </svg>
    {/if}
  </div>
{/each}

<style>
  .backgroundBar {
    width: 100%;
    position: absolute;
    z-index: 0;
    top: 0;
    background-position: top left;
    opacity: 0;
  }
  .backgroundBar .wave {
    position: absolute;
    bottom: -10px;
  }
  @media (max-width: 768px) {
    .backgroundBar .wave {
      display: none;
    }
  }
  .backgroundBar .wave path {
    fill: var(--background);
  }
  .backgroundBar.active {
    opacity: 1;
  }
</style>
